// @flow

import React, { type Node } from 'react'
import { useSelector } from 'react-redux'
import { and, has, isEmpty, not } from 'ramda'

import {
  isGoogleAnalyticsEnabled as getGoogleAnalyticsEnabled,
  getGoogleAnalyticsName,
  getGoogleAnalyticsConfig,
} from '@alphaott/app-main/selectors'

import { GoogleAnalyticsProvider, OpenPanelProvider } from '../providers'
import type { Source } from '../utils'

import { ANALYTICS_PLUGINS } from '../const'

export type GoogleAnalyticsInitProps = {
  children: Node,
}

const GoogleAnalyticsInit = ({ children }: GoogleAnalyticsInitProps) => {
  const analyticsName = useSelector(getGoogleAnalyticsName)
  const analyticsConfig = useSelector(getGoogleAnalyticsConfig)

  const isAvailableConfig = and(not(isEmpty(analyticsConfig)), has(analyticsName)(ANALYTICS_PLUGINS))

  if (isAvailableConfig) {
    return <GoogleAnalyticsProvider>{children}</GoogleAnalyticsProvider>
  }

  return children
}

export type AppAnalyticsProps = GoogleAnalyticsInitProps & {
  source: Source,
}

export const AppAnalytics = ({ source, children }: AppAnalyticsProps) => {
  const isGoogleAnalyticsEnabled = useSelector(getGoogleAnalyticsEnabled)

  const baseAnalytics = <OpenPanelProvider source={source}>{children}</OpenPanelProvider>

  if (isGoogleAnalyticsEnabled) {
    return <GoogleAnalyticsInit>{baseAnalytics}</GoogleAnalyticsInit>
  }

  return baseAnalytics
}

export default AppAnalytics
